<template>
  <div>


<h2 class="goth">Hur ofta</h2>

<div class="grammatikparagrafbredd leftorient">

<div class="quasi-p">
  Nedan finns några ord som kan användas som svar på frågan <b><i>wie oft?</i></b> <i>(hur ofta?)</i>
</div>


<table class="">
<br>

    <tr class="leftorient">
        <td class="ljusgra"><i><b>immer</b></i></td>
        <td class="ljusgra"><i>alltid</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>oft</b></i></td>
      <td class="ljusgra"><i>ofta</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>manchmal</b></i></td>
      <td class="ljusgra"><i>ibland</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>ab und zu</b></i></td>
      <td class="ljusgra"><i>då och då</i></td>
    </tr>


    <tr class="leftorient">
      <td class="ljusgra"><i><b>selten</b></i></td>
      <td class="ljusgra"><i>sällan</i></td>
    </tr>

    <tr class="leftorient">
      <td class="ljusgra"><i><b>nie</b></i></td>
      <td class="ljusgra"><i>aldrig</i></td>
    </tr>



</table>
<br><br>
<div class="quasi-p">
  För uttrycka handlingar som förekommer vid upprepade gånger vid speciella tillfällen kan man använda
  nån form av ordet <b><i>varje</i></b> som på tyska i detta fallet blir <b><i>jeden, jedes</i></b> eller <b><i>jede</i></b>.
</div>
<div class="quasi-p">
  Vilket av orden som används beror på det kommande ordets genus (och det står i ackusativ).
</div>






    <table class="">
    <br>

        <tr class="leftorient">
            <td class="ljusgra"><i><b>jeden Tag</b></i></td>
            <td class="ljusgra"><i>varje</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>jeden Abend</b></i></td>
            <td class="ljusgra"><i>varje kväll</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>jeden Mittwoch</b></i></td>
            <td class="ljusgra"><i>varje onsdag</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>jedes Jahr</b></i></td>
            <td class="ljusgra"><i>varje år</i></td>
        </tr>


        <tr class="leftorient">
            <td class="ljusgra"><i><b>jede Nacht</b></i></td>
            <td class="ljusgra"><i>varje natt</i></td>
        </tr>


      </table>



<br><br>


  <div class="quasi-p">

    Vid dagar eller delar av dagar kan man också använda ett <b>s</b> efter ordet för att uttrycka att det rör sig
    om vanor / upprepade händelser.
  </div>



<br>

<div class="ruta">
    <div class="quasi-p"><i>Abend<b>s</b> mache ich Hausaufgaben.</i><br>På kvällarna gör jag läxor.</div>

    <div class="quasi-p"><i>Dienstag<b>s</b> und Donnerstag<b>s</b> spiele ich Fußball.</i><br>På tisdagar och torsdagar
    spelar jag fotboll.</div>
</div>





</div>

</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "när als wann wenn"
            }
        ]
    }
}

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
